// shared/ui/GuardarRegistroButton.jsx  (ui). Botón primario del pie de los formularios, con estado de carga en el sitio.
import React from 'react';
import { CircularProgress } from '@mui/material';
import { BtnNuevo } from '../../../../nuup/componentes/Toolbar/ListToolbar.jsx';

const GuardarRegistroButton = ({ saving = false, onClick }) => (
  <BtnNuevo icon={saving ? null : 'fa-check'} onClick={onClick} disabled={saving}>
    {saving ? (
      <>
        <CircularProgress size={14} color="inherit" className="mr-2" style={{ verticalAlign: 'text-bottom' }} aria-hidden="true" />
        Guardando…
      </>
    ) : (
      'Guardar Registro'
    )}
  </BtnNuevo>
);

export default GuardarRegistroButton;
